import { useTranslation } from 'react-i18next'
import { IconExit } from 'components/Icons'
import { useFeatureToggle } from 'hooks'
import {
  DropdownMenuItemStyled,
  ContainerWithIconStyled,
  LinkStyled,
} from './LogoutMenuStyled'

export const LogoutMenu = () => {
  const { t } = useTranslation()
  const isArcMosaico = useFeatureToggle('arc-mosaico-project') as boolean

  const logOut = async () => {
    window.location.replace('/account/signout')
  }

  return (
    <DropdownMenuItemStyled>
      <ContainerWithIconStyled>
        <IconExit />
        <LinkStyled rel='nofollow' onClick={logOut} $color={isArcMosaico ? '#fa5252' : undefined}>
          {t('logout')}
        </LinkStyled>
      </ContainerWithIconStyled>
    </DropdownMenuItemStyled>
  )
}
